import template from './checkoutAddressList.html';

import _ from 'lodash';

class CheckoutAddressListController {
    /*@ngInject*/
    constructor($q, dataContext, cartService, constants, $uibModal) {
        this.$q = $q;
        this.dataContext = dataContext;
        this.cartService = cartService;
        this.constants = constants;
        this.$uibModal = $uibModal;
        
        this.updateBillingAddress = this.updateBillingAddress.bind(this);
        this.updateShippingAddress = this.updateShippingAddress.bind(this);
    }

    $onInit() {
        this.isLoading.updateShippingAddress = true;

        this.states = [];
        this.shippingAddress = null;
        this.originalShippingAddress = null;
        this.billingAddress = null;

        this.getAvailableCountries()
            .then(() => {
                return this.dataContext.account.getCustomerInfo()
                    .then((result) => {
                        this.customer = _.cloneDeep(result.CustomerInformation);
                        this.updateBillingAddress(result.BillingAddress);
                        this.updateShippingAddress(result.ShippingAddress);
                    });
            })
            .finally(() => {
                this.isLoading.updateShippingAddress = false;
            });
    }

    updateBillingAddress(address) {
        if (_.isFunction(this.onSelected) && !_.isNil(address)) {
            this.fillCountryInfo(address);
            return this.validateAddress(address)
                .then((response) => {
                    let copy = _.cloneDeep(response);

                    this.billingAddress = copy;

                    this.onSelected({
                        billing: this.toShopAddress(copy, 'billing')
                    });
                });
        }
    }

    updateShippingAddress(address) {
        if (_.isFunction(this.onSelected) && !_.isNil(address)) {
            this.fillCountryInfo(address);
            this.isLoading.updateShippingAddress = true;
            return this.validateAddress(address).then((response) => {
                let copy = _.cloneDeep(response);

                this.shippingAddress = copy;
                this.originalShippingAddress = _.cloneDeep(this.shippingAddress);

                this.onSelected({
                    shipping: this.toShopAddress(copy, 'shipping')
                });

                this.onUpdateShippingAddress({ address: this.toShopAddress(copy, 'shipping')});   
                this.isLoading.updateShippingAddress = false;
            });
        }
    }

    validateAddress(address) {
        let formattedAddress = {
            Address1: address.Address1,
            Address2: address.Address2,
            City: address.City,
            PostalCode: address.PostalCode,
            State: address.State.code
        };
        return this.dataContext.address.validateAddress(formattedAddress)
            .then((response) => {
                if (!this.dataContext.address.isValidResponse(response)) {
                    let returnedAddress = {
                        Address1: address.Address1,
                        Address2: address.Address2,
                        City: response.City,
                        PostalCode: response.PostalCode,
                        State: response.StateAbrev,
                        StateName: response.StateFull
                    };

                    let modalInstance = this.$uibModal.open({
                        template: '<fp-address-validation-modal config="config"></fp-address-validation-modal>',
                        controller: ($scope) => {
                            'ngInject';
                            $scope.config = {
                                data: address,
                                close: modalInstance.close,
                                dismiss: modalInstance.dismiss,
                                returnedAddress: returnedAddress
                            };
                        }
                    });

                    return modalInstance.result.then((result) => {
                        if (_.isNil(result)) {
                            this.isEditMode = false;
                            return this.originalShippingAddress;
                        } else {
                            if (address.State !== result.State || address.City !== result.City) {
                                address.State = result.State;
                                address.City = result.City;
                            }
                            return address;
                        }
                    });
                } else {
                    return address;
                }
            });
    }

    fillCountryInfo(address) {
        if (_.isString(address.State)) {
            address.State = _.find(this.states, (s) => {
                return s.code === address.State;
            });
        }

        if (_.isNil(address.Country)) {
            address.Country = address.State.country;
        }
        return address;
    }

    toShopAddress(fpAddress, addressType) {
        let name = !_.isNil(fpAddress.Attention) ? _.split(fpAddress.Attention, ' ') : null;
        return {
            City: fpAddress.City,
            Attention: fpAddress.Attention,
            FirstName: !_.isNil(_.first(name)) ? _.first(name) : this.customer.FirstName,
            LastName: !_.isNil(_.last(name)) ? _.last(name) : this.customer.LastName,
            CountryCode: _.get(fpAddress, 'Country.code3', 'US'),
            CountryName: fpAddress.Country.name,
            Line1: fpAddress.Address1,
            Line2: fpAddress.Address2,
            PostalCode: fpAddress.PostalCode,
            RegionId: fpAddress.State.code,
            RegionName: fpAddress.State.name,
            Type: addressType
        };
    }

    getAvailableCountries() {
        return this.cartService.getCountries()
            .then((response) => {
                this.countries = _.filter(response.data, (c) => {
                    return _.some(this.constants.supportedCountries, (sc) => sc === c.code2);
                });
                return this.countries;
            })
            .then((countries) => {
                let temp = [];

                return this.$q.all(_.map(countries, (c) => {
                    return this.getCountryRegions(c)
                        .then((states) => {
                            _.each(states, (s) => {
                                s.country = c;
                            });
                            temp = _.concat(temp, states);
                        });
                }))
                .finally(() => {
                    this.states = temp;
                });
            });
    }

    getCountryRegions(country) {
        return this.cartService.getCountryRegions(country.code3)
            .then((response) => {
                return response.data;
            });
    }
}

export default {
template: template,
    bindings: {
    onSelected : '<',
    onUpdateShippingAddress: '&',
    isLoading: '='
    },
controller: CheckoutAddressListController
};